namespace GeniuzPOS.QRreport {
    export interface QRywcSpecReportCusPromotionSaleForm {
        ReportId: Serenity.LookupEditor;
        ReportName: Serenity.StringEditor;
        UrlReport: Serenity.StringEditor;
        DataStructureName: Serenity.StringEditor;
        LineNo: Serenity.IntegerEditor;
        DateBegin: Serenity.DateEditor;
        DateEnd: Serenity.DateEditor;
        PromoCampaign: Serenity.LookupEditor;
        PromoId: Serenity.StringEditor;
        ShopId: Serenity.LookupEditor;
        CatCode: Serenity.LookupEditor;
        SubCat1Code: Serenity.LookupEditor;
        SubCat2Code: Serenity.LookupEditor;
        BrandCode: Serenity.LookupEditor;
        pSequenFg: Serenity.RadioButtonEditor;
    }

    export class QRywcSpecReportCusPromotionSaleForm extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QRywcSpecReportCusPromotionSale';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QRywcSpecReportCusPromotionSaleForm.init)  {
                QRywcSpecReportCusPromotionSaleForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DateEditor;
                var w4 = s.RadioButtonEditor;

                Q.initFormType(QRywcSpecReportCusPromotionSaleForm, [
                    'ReportId', w0,
                    'ReportName', w1,
                    'UrlReport', w1,
                    'DataStructureName', w1,
                    'LineNo', w2,
                    'DateBegin', w3,
                    'DateEnd', w3,
                    'PromoCampaign', w0,
                    'PromoId', w1,
                    'ShopId', w0,
                    'CatCode', w0,
                    'SubCat1Code', w0,
                    'SubCat2Code', w0,
                    'BrandCode', w0,
                    'pSequenFg', w4
                ]);
            }
        }
    }
}
